

import { Colors, FInter, FlexBox, MEDIA } from '@brg/ui';
import styled, { css} from 'styled-components';
import { OverflowContainer } from '../projectCard/styles';

export const DesignerCardLayoutWrapper = styled(FlexBox)`
    cursor: pointer;
    transition: all 0.2s;
    .dct {
        transition: all 0.2s;
    }
    &:hover {
        .dct {
            color: ${Colors.generalPeaGreen};
        }
    }
`;

export const RatingModalWrapper = styled(FlexBox)`
    position: absolute;
    top: 24px;
    right: -8px;
    width: max-content;
    background-color: ${Colors.geo};
    border: 1px solid ${Colors.geoWhite73};
    border-radius: 8px;
    padding: 8px;
    ::before,
    ::after {
        content: '';
        position: absolute;
        bottom: 100%;
        right: 10px;
        /* border: 5px solid transparent; */
        /* border-bottom-color: #dddddd; */
    }
    ::after {
        /* right: 20px; */
        border: 6px solid transparent;
        border-bottom-color: ${Colors.geoWhite73};
    }

    .left_col {
        text-align: right;
    }
    .right_col {
        white-space: pre;
    }
`;

export const OpaCardText = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};
`;

export const SelectedWrapper = styled(OverflowContainer)`
    margin-top: 10px !important;
    height: auto;
    > div {
        margin-left: auto;
        margin-right: 16px;
    }
`;

export const TooltipWrapper = styled(OverflowContainer)`
    > div {
     margin-top: 16px;
        margin-left: auto;
        margin-right: 16px;
    }
`;

export const TitleText = styled(FInter.SmallTextFlex)<{ isLargeSize?: boolean }>`
    ${({ isLargeSize }) => isLargeSize && css`
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;

        @media${MEDIA.TABLET} {
            font-size: 15px;
            line-height: 20px;
        }
    `}
`;


import { Colors, FInter, FlexBox, MEDIA } from '@brg/ui';
import styled, { css} from 'styled-components';
import { OverflowContainer } from '../projectCard/styles';

export const DesignerCardLayoutWrapper = styled(FlexBox)`
    cursor: pointer;
    transition: all 0.2s;
    .dct {
        transition: all 0.2s;
    }
    &:hover {
        .dct {
            color: ${Colors.generalPeaGreen};
        }
    }
`;

export const RatingModalWrapper = styled(FlexBox)`
    position: absolute;
    top: 24px;
    right: -8px;
    width: max-content;
    background-color: ${Colors.geo};
    border: 1px solid ${Colors.geoWhite73};
    border-radius: 8px;
    padding: 8px;
    ::before,
    ::after {
        content: '';
        position: absolute;
        bottom: 100%;
        right: 10px;
        /* border: 5px solid transparent; */
        /* border-bottom-color: #dddddd; */
    }
    ::after {
        /* right: 20px; */
        border: 6px solid transparent;
        border-bottom-color: ${Colors.geoWhite73};
    }

    .left_col {
        text-align: right;
    }
    .right_col {
        white-space: pre;
    }
`;

export const OpaCardText = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};
`;

export const SelectedWrapper = styled(OverflowContainer)`
    margin-top: 10px !important;
    height: auto;
    > div {
        margin-left: auto;
        margin-right: 16px;
    }
`;

export const TooltipWrapper = styled(OverflowContainer)`
    > div {
     margin-top: 16px;
        margin-left: auto;
        margin-right: 16px;
    }
`;

export const TitleText = styled(FInter.SmallTextFlex)<{ isLargeSize?: boolean }>`
    ${({ isLargeSize }) => isLargeSize && css`
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;

        @media${MEDIA.TABLET} {
            font-size: 15px;
            line-height: 20px;
        }
    `}
`;
